import React, { useState } from "react";
import "../assets/styles/HomePage.css";
import { useNavigate } from "react-router-dom";
import { FaPaperPlane, FaSync } from "react-icons/fa"; // Added FaSync for refresh
import { getDownloadedFile, getFileMetaData } from "../assets/scripts/apiClient"; // API functions
import norton from "../assets/icons/norton.svg";
import biliBili from "../assets/icons/bilibili-seeklogo.png";
import odysee from "../assets/icons/odysee.png";
import bitchute from "../assets/icons/bitchute.png";
import rumble from "../assets/icons/rumble.png";
import vkVideos from "../assets/icons/VK_Video_RU.png";
import rutubeSeeklogo from "../assets/icons/rutube-seeklogo.png";
import yandex from "../assets/icons/yandex.png";



import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faYoutube, faTwitter, faInstagram, faFacebook, faTiktok, faVimeo, faDailymotion } from '@fortawesome/free-brands-svg-icons';
/*import streamSaver from 'streamsaver';*/



function HomePage() {  
  const [url, setUrl] = useState('');
  const [submitError, setSubmitError] = useState(null);
  const [videoMeta, setVideoMeta] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedFormat, setSelectedFormat] = useState('best');
  const [isDownloading, setIsDownloading] = useState(false);
  


  const navigate = useNavigate(); // Initialize navigation hook


  const handleDownload = async () => {
    if (!videoMeta?.file_metadata_id) return;
  
    setIsDownloading(true);
    const payload = {
      file_metadata_id: videoMeta.file_metadata_id,
      av_format: selectedFormat,
      url: videoMeta.url,
      duration: videoMeta.duration,
      resolution: videoMeta.resolution,
      thumbnail: videoMeta.thumbnail,
      title: videoMeta.title
    };
  
    console.log(payload);

    try {
      const apiUrl = "/activity/download-file"; // Replace with actual API URL
  

      const response = await getDownloadedFile(apiUrl, payload);
      setIsDownloading(false);
  
      if (response?.downloadUrl) {
        /*
        const fileStream = streamSaver.createWriteStream(response.filename || 'download.mp4');
        const writer = fileStream.getWriter();
  
        const res = await fetch(response.downloadUrl);
        const reader = res.body.getReader();
  
        const pump = async () => {
          const { done, value } = await reader.read();
          if (done) {
            writer.close();
            return;
          }
          writer.write(value);
          pump();
        };
  
        pump();      */

        
        const link = document.createElement('a');
        link.href = response.downloadUrl;
        link.download = response.filename || 'video.mp4';
        document.body.appendChild(link);
        link.click();
        link.remove();

        } else {
        alert('Download failed or URL not returned.');
      }
    } catch (err) {
      setIsDownloading(false);
      alert(err.message || 'Download failed.');
    }
  };
  

  async function handleSubmit(e) {
    e.preventDefault();
    setSubmitError(null); // Clear previous errors
    
    if (!url) {
      setSubmitError("URL field cannot be empty.");
      return;
    }

    const apiUrl = "/activity/get-metadata"; // Replace with actual API URL
    const payload = { url };

    try {
      setIsLoading(true);
      const response = await getFileMetaData(apiUrl, payload); 
      setIsLoading(false);

      if (response.success === false) {
        if (response.message.includes("401")) {          
          navigate('/login');
        } else {
          setSubmitError(response.message);
        }
      } else {        
        setVideoMeta(response); // Store metadata
        setUrl(""); // Clear input field
      }
    } catch (err) {
      //console.error("Request failed:", err);
      setIsLoading(false);
      setSubmitError(err.message || "An error occurred while submitting.");
    }
  }


  return (
  <>
    {isDownloading && <div className="overlay" />}

    <div className="home-page">
    
      <div className="recommended-use-cases">
        <h1>🔥 Download-videos - Free & Easy! 📥 </h1>
        <p className="platform-list">
          <span className="platform">
            Choose among 500+ plaftorms including <FontAwesomeIcon icon={faYoutube} className="icon youtube" /> YouTube
          </span>
          <span className="platform">
            <FontAwesomeIcon icon={faVimeo} className="icon vimeo" /> Vimeo
          </span>
          <span className="platform">
            <FontAwesomeIcon icon={faDailymotion} className="icon dailymotion" /> Dailymotion
          </span>
          <span className="platform">
            <FontAwesomeIcon icon={faTwitter} className="icon twitter" /> Twitter
          </span>
          <span className="platform">
            <FontAwesomeIcon icon={faTiktok} className="icon tiktok" /> TikTok
          </span>
          <span className="platform">
            <FontAwesomeIcon icon={faInstagram} className="icon instagram" /> Instagram
          </span>
          <span className="platform">
            <FontAwesomeIcon icon={faFacebook} className="icon facebook" /> Facebook
          </span>
          <span className="platform">
            <img src={rumble} alt="Rumble" className="icon rumble" />
          </span>
          <span className="platform">
            <img src={bitchute} alt="BitChute" className="icon bitchute" />
          </span>
          <span className="platform">
            <img src={odysee} alt="Odysee" className="icon odysee" /> Odysee
          </span>
          <span className="platform">
            <img src={biliBili} alt="bilibili" className="icon bilibili" />
          </span>
          <span className="platform">
            <img src={vkVideos} alt="vkvideos" className="icon vkVideos" />
          </span>
          <span className="platform">
            <img src={rutubeSeeklogo} alt="rutube" className="icon rutube-seeklogo" />
          </span>
          <span className="platform">
            <a href="https://yandex.ru/video/search?text=популярные+видео" target="_blank"  rel="noreferrer" > <img src={yandex} alt="yandex" className="icon yandex" /></a>
          </span>          
          ...
        </p>
      </div>


    <div className="recommended-use-cases">  
    {isDownloading && (
        <div className="overlay">
          <div className="center-spinner">
            <FaSync className="spin" size={32} />
            <p>Preparing your download...</p>
          </div>
        </div>
      )}
        <form onSubmit={handleSubmit} className="home-form">
          <div className="input-button-container" style={{ fontSize: "smaller" }}>
            <input
              style={{ color: "#7393B3" }}
              type="url"
              value={url}
              onChange={(e) => setUrl(e.target.value)}
              className="form-control"
              placeholder="Enter the URL..."
              required
            />
            <button type="submit" disabled={isLoading}>
              {isLoading ? <FaSync className="spin" /> : <FaPaperPlane />}
            </button>
          </div>
          <span style={{fontSize: "smaller"}}>
          Downloading any copyrighted materials is strictly prohibited, please read our <a style={{color: "#f1c40f"}} href="/terms-of-use" >terms</a>.
          </span>


          {/* Error message under URL input */}
          {submitError && <p style={{fontSize: "10pt", color: "red"}} className="text-red-500 mt-2">{submitError}</p>}
        </form>
        {videoMeta && (
          <div className="video-meta-card">
            <div className="video-thumbnail-wrapper">
              <img src={videoMeta.thumbnail} alt="Video Thumbnail" className="video-thumbnail" />
              <div className="download-options">
                <button
                  onClick={handleDownload}
                  className="download-button"
                  disabled={isDownloading}>
                  {isDownloading ? <FaSync className="spin" /> : 'Download Video'}
                </button>
                <select
                  className="format-select"
                  value={selectedFormat}
                  onChange={(e) => setSelectedFormat(e.target.value)}>
                    <option value="best">🎞️ Best</option>
                    <option value="1080">🎞️ 1080p</option>
                    <option value="720">🎞️ 720p</option>
                    <option value="480">🎞️ 480p</option>
                    <option value="360">🎞️ 360p</option>
                    <option value="worst">🎞️ Worst</option>
                    <option value="audioonly"> 🔊 MP3 </option>
                </select>
              </div>
            </div>
            <div className="video-meta-details">
              <h3>{videoMeta.title}</h3>
              <p><strong>URL:</strong> <a href={videoMeta.url} target="_blank" rel="noopener noreferrer">{videoMeta.url}</a></p>
              <p><strong>Resolution:</strong> {videoMeta.resolution}</p>
              <p><strong>Duration:</strong> {videoMeta.duration} min</p>
            </div>
          </div>
        )}


    </div>
    <div className="recommended-use-cases">
        
      <div
        style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "20px",
            flexWrap: "wrap",
            maxWidth: "800px",
            padding: "20px 0",
            margin: "0 auto",
            textAlign: "center",
            fontWeight: "bold",
        }}>
        <span>🤯Absolutely Free</span>
        <span>🌐 500+ </span>
        <span>🚀Unlimited Hours</span>
        <span><img src={norton} alt="norton security" style={{ width: "10%" }} /> Norton<sup style={{ fontSize: "8pt" }}>TM</sup> Safe Web </span>
        <span>🔗Direct URLs </span>
      </div>
    </div>


      <div className="recommended-use-cases">          
          <ul>
              <li>✅ <strong>Download Videos/Reels/Stories</strong> – download online videos for absolutely free 🎉.</li>
              <li>✅ <strong>Download Music</strong> – convert video to high quality audios, download audio 🎧.</li>
              <li>✅ <strong>No Subscription</strong> – simple to use, no subscriptions or logins required.</li>
              <li>✅ <strong>Safe</strong> – no adds, no shady pop-ups.</li>
              <li>✅ <strong>Simple</strong> – just provide the URL and hit search.</li>
              <li>✅ <strong>Video Downscaling</strong> – choose between various available formates.</li>
              <li>✅ <strong>Video Upscaling</strong> – we are working on upscaling your bad quality videos, stay tuned.</li>
              <li>✅ <strong>Transcription</strong> – want to generate transcipts of online vidoes, visit <a style={{color: "#f1c40f", textDecoration: "none"}} href="https://transcriptit.xyz"> transcriptit.xyz</a>.</li>                            
          </ul>
      </div>

    </div>
    </>
  );
}

export default HomePage;
